import { getKeywordFromString } from "src/app/utils/keywordsHelper";
import { IData } from "./BulkSiloUtils";
import { useMemo } from "react";

export type IHandleSiloOrderInfo = (
    index: number,
    field: "keyword" | "date" | "anchor",
    value: string
) => void;

export interface ISiloOrderInfoFrom {
    data?: IData;
}
const SiloOrderInfoFrom = (props: ISiloOrderInfoFrom) => {
    const { data } = props;

    const allKeyword = useMemo(
        () => [
            ...(data?.selectedKeywords || []),
            ...(data?.userKeywords ? getKeywordFromString(data?.userKeywords) : []),
        ],
        [data?.selectedKeywords, data?.userKeywords]
    );

    return (
        <>
            <ul>
                {allKeyword.map((keyword, index) => {
                    return <li key={index}>{keyword}</li>;
                })}
            </ul>
        </>
    );
};

export default SiloOrderInfoFrom;
